import { getApi } from '@wix/video-maker-api';

const { videoMakerApi, videoMakerJobQueue } = getApi();

export { videoMakerApi, videoMakerJobQueue };
